"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.motorRepairType = void 0;
exports.motorRepairType = { "DEALER": { "name": { "code": "DEALER", "localize": { "en": "Dealer", "th": "ศูนย์บริการ" } } }, "GARAGE": { "name": { "code": "GARAGE", "localize": { "en": "Garage", "th": "อู่ในเครือ" } } } };
